import { render, staticRenderFns } from "./ReferralsAddReport.vue?vue&type=template&id=492721a1"
import script from "./ReferralsAddReport.vue?vue&type=script&lang=js"
export * from "./ReferralsAddReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports